<template>
  <form name="form">
    <b-modal id="AddCertificate" hide-footer size="xl">
      <template #modal-title> Dodanie nowego certyfikatu </template>

      <div class="row">
        <div class="col">
          <label for="ProducerName" class="form-label">Nazwa Dostawcy</label>
          <input
            type="text"
            class="form-control"
            id="ProducerName"
            v-model="producer.name"
            disabled="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="certificateName" class="form-label"
            >Nazwa Certyfikatu</label
          >
          <input
            type="text"
            class="form-control"
            id="certificateName"
            v-model="form.certificateName"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="validFrom" class="form-label">Certyfikat ważny od</label>
          <b-form-datepicker
            id="validFrom"
            v-model="form.validFrom"
            class="mb-2"
          ></b-form-datepicker>
        </div>
        <div class="col">
          <label for="validTo" class="form-label">Certyfikat ważny do</label>
          <b-form-datepicker
            id="validTo"
            v-model="form.validTo"
            class="mb-2"
          ></b-form-datepicker>
        </div>
      </div>

      <div class="col align-self-end div-form-buttons-area">
        <button class="btn btn-primary" type="button" @click="SaveData">
          Zapisz
        </button>
        <button
          class="btn btn-warning"
          type="button"
          @click="ClearFormAndCloseWindow"
        >
          Zamknij
        </button>
      </div>
    </b-modal>
  </form>
</template>

<script>
import axios from "axios";
import urlConfig from "../../../../mixins/url";

export default {
  components: {},
  mixins: [urlConfig],
  props: ["producer"],
  data() {
    return {
      producerName: this.producer.name,
      form: {
        producerId: 0,
        certificateName: "",
        validFrom: undefined,
        validTo: undefined,
      },
      formErrors: [],
    };
  },
  methods: {
    ClearFormAndCloseWindow() {
      this.$bvModal.hide("AddCertificate");
      this.form = {
        producerId: 0,
        certificateName: "",
        validFrom: undefined,
        validTo: undefined,
      };
      this.formErrors = [];
    },
    SaveData() {
      this.formErrors = [];
      this.form.producerId = this.producer.id;
      this.ValidateForm();
      if (this.formErrors.length == 0) {
        var url = this.url.serverUrl + this.url.Producer.AddCertificate;
        var that = this;
        axios
          .post(url, this.form)
          .then(function (res) {
            that.form.id = res.data;
            that.$emit("CertificateWasAdded", that.form);
            that.ClearFormAndCloseWindow();
          })
          .catch(function (e) {
            console.log(e);
          });
      }
    },
    ValidateForm() {
      if (!this.form.certificateName) {
        this.formErrors.push("certificateNameError");
      }
      if (!this.form.validFrom) {
        this.formErrors.push("validFromError");
      }
      if (!this.form.validTo) {
        this.formErrors.push("validToError");
      }
    },
  },
};
</script>